import React from "react";
import { Outlet } from "react-router-dom";
import AuthBrandPanel from "./AuthBrandPanel";
import styles from "./AuthLayout.module.scss";

function AuthLayout() {
  return (
    <section className={`${styles.page}`}>
      <div className={`${styles.content} bg-app-primary`}>
        <AuthBrandPanel />
        <div className={`${styles["right-panel"]}`}>
          <div className={`${styles["form-container"]}`}>
            <img
              src={"/assets/images/scandi-name-automation.png"}
              className="header-brand-img text-start mx-auto w-75"
              alt="logo"
            />
            <div className="d-flex flex-column h-100 justify-content-center">
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default AuthLayout;
